<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11T0VXm/tc-custom/9783956760396_IMGJPG_FrontCover_0.jpg?1703129287820" alt="This image is the cover for the book Heidi, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heidi, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>"Heidi" is a delightful story for children of life in the Alps, one of many tales written by the Swiss authoress, Johanna Spyri, who died in her home at Zurich in 1891. She had been well known to the younger readers of her own country since 1880, when she published her story "Heimathlos", which ran into three or more editions, and which, like her other books, as she states on the title page, was written for those who love children, as well as for the youngsters themselves. Her own sympathy with the instincts and longings of the child's heart is shown in her picture of Heidi. The record of the early life of this Swiss child amid the beauties of her passionately loved mountain-home and during her exile in the great town has been for many years a favourite book of younger readers in gery and America.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Johanna Spyri
      </h2>
      
      <p class="authorDescription body article">Johanna Louise Spyri 12 June 1827 – 7 July 1901) was a Swiss-born author of novels, notably children's stories, and is best known for her book Heidi. Born in Hirzel, a rural area in the canton of Zurich, Switzerland, as a child she spent several summers near Chur in Graubünden, the setting she later would use in her novels. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d7da2570